import MenuTitle from 'components/MenuTitle'

class ActionBar extends React.Component {
  render () {
    return (
      <div>
        <MenuTitle menuTitle='Role' />
        <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding action-role'>
          <span className='pull-right'>
            <button onClick={this._onClickNewRole} className='btn btn-primary'> Create Role </button>
          </span>
        </div>
      </div>
    )
  }

  _onClickNewRole = () => {
    this.props.onClickNewRole()
  }
}

export default ActionBar



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/ActionBar/ActionBar.js